import React from "react";
import {css} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getOfferTypeNamePlural} from "../../../../offer/helpers/OfferType";
import {OfferType} from "../../../../offer/types/OfferType";

interface ISoldOffer {
    id: number;
    name: string;
    region: {
        short_name: string;
    };
    slug: string;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    groups: IOfferGroupsSimplified | null;
}

export interface VendorDetailSoldOfferBoxProps {
    offer: ISoldOffer;
    vendorSlug: string;
}

export const VendorDetailSoldOfferBox: React.FC<VendorDetailSoldOfferBoxProps> = ({offer, vendorSlug}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerAddress = `${offer.region.short_name}, ${offer.street_name && `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`}`;

    return (
        <a href={offerLink} className={soldOffersListItemStyle} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodySimple className={cardBodyStyle}>
                    <div className={infoTextHolderStyle}>
                        <Text as="h3" variant="headline_5" className={titleStyle}>
                            {offer.name}{" "}
                            <Text as="span" variant="info_txt_1" className={noWrapStyle}>
                                ({getOfferTypeNamePlural(offer.type)})
                            </Text>
                        </Text>
                        <Text as="p" variant="body_copy_2" className={addressStyle}>
                            {offerAddress}
                        </Text>
                    </div>
                    <div className={badgeHolderStyle}>
                        <Badge variant="label_secondary">Oferta archiwalna</Badge>
                    </div>
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </a>
    );
};

const cardBodyStyle = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%"
});

const infoTextHolderStyle = css({
    width: "100%",
    flex: "1 1 auto",
    md: {
        width: "auto"
    }
});

const titleStyle = css({
    marginBottom: 1
});

const addressStyle = css({
    marginBottom: 2
});

const noWrapStyle = css({
    whiteSpace: "nowrap",
    display: "block",
    md: {
        display: "inline-block"
    }
});

const badgeHolderStyle = css({
    alignSelf: "center",
    flex: "0 0 auto"
});

const soldOffersListItemStyle = css({
    _hover: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {Text} from "@pg-design/text-module";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferGroupsSimplified} from "../../../../offer/detail/types/IOfferGroups";
import {getOfferTypeNamePlural} from "../../../../offer/helpers/OfferType";
import {OfferType} from "../../../../offer/types/OfferType";

interface ISoldOffer {
    id: number;
    name: string;
    region: {
        short_name: string;
    };
    slug: string;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    groups: IOfferGroupsSimplified | null;
}

export interface VendorDetailSoldOfferBoxProps {
    offer: ISoldOffer;
    vendorSlug: string;
}

export const VendorDetailSoldOfferBox: React.FC<VendorDetailSoldOfferBoxProps> = ({offer, vendorSlug}) => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerLink = useOfferLink({
        ...offer,
        vendor: {slug: vendorSlug}
    });

    const offerAddress = `${offer.region.short_name}, ${offer.street_name && `${offer.street_name} ${offer.street_number ? offer.street_number : ""}`}`;

    return (
        <a href={offerLink} className={soldOffersListItemStyle} target={responsiveLinkTarget}>
            <ResponsiveCard>
                <ResponsiveCard.BodySimple className={cardBodyStyle}>
                    <div className={infoTextHolderStyle}>
                        <Text as="h3" variant="headline_5" className={titleStyle}>
                            {offer.name}{" "}
                            <Text as="span" variant="info_txt_1" className={noWrapStyle}>
                                ({getOfferTypeNamePlural(offer.type)})
                            </Text>
                        </Text>
                        <Text as="p" variant="body_copy_2" className={addressStyle}>
                            {offerAddress}
                        </Text>
                    </div>
                    <div className={badgeHolderStyle}>
                        <Badge variant="label_secondary">Oferta archiwalna</Badge>
                    </div>
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </a>
    );
};

const cardBodyStyle = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%"
});

const infoTextHolderStyle = css({
    width: "100%",
    flex: "1 1 auto",
    md: {
        width: "auto"
    }
});

const titleStyle = css({
    marginBottom: 1
});

const addressStyle = css({
    marginBottom: 2
});

const noWrapStyle = css({
    whiteSpace: "nowrap",
    display: "block",
    md: {
        display: "inline-block"
    }
});

const badgeHolderStyle = css({
    alignSelf: "center",
    flex: "0 0 auto"
});

const soldOffersListItemStyle = css({
    _hover: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});
